import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { GetPurchaseEffects } from './store/get-purchase.effects';
import { reducer } from './store/get-purchase.reducers';
import { StoreModule } from '@ngrx/store';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([ GetPurchaseEffects ]),
    StoreModule.forFeature('getPurchase', reducer),
  ]
})
export class GetPurchaseModule {}
